var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreyCircleDash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8888 1.09545C3.95772 0.381218 5.21442 0 6.5 0C8.22391 0 9.87721 0.68482 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 7.78558 12.6188 9.04228 11.9046 10.1112C11.1903 11.1801 10.1752 12.0132 8.98744 12.5052C7.79972 12.9972 6.49279 13.1259 5.23191 12.8751C3.97104 12.6243 2.81285 12.0052 1.90381 11.0962C0.994768 10.1872 0.375703 9.02896 0.124899 7.76809C-0.125905 6.50721 0.00281634 5.20028 0.494786 4.01256C0.986755 2.82484 1.81988 1.80968 2.8888 1.09545ZM7.0416 7.04191L5.9584 7.04122L3.43599 7.04191C3.36486 7.04195 3.29443 7.02799 3.2287 7.00081C3.16297 6.97364 3.10324 6.93378 3.05292 6.88352C3.0026 6.83326 2.96266 6.77358 2.9354 6.70789C2.90815 6.6422 2.89409 6.57178 2.89405 6.50065C2.894 6.42953 2.90797 6.35909 2.93514 6.29337C2.96232 6.22764 3.00218 6.16791 3.05243 6.11759C3.1027 6.06726 3.16237 6.02733 3.22807 6.00007C3.29376 5.97281 3.36418 5.95876 3.4353 5.95871L5.9584 5.95871L7.0416 5.9594L9.5647 5.9594C9.70834 5.95931 9.84613 6.01628 9.94777 6.11779C10.0494 6.21929 10.1065 6.35701 10.1066 6.50065C10.1067 6.64429 10.0498 6.78209 9.94825 6.88372C9.84675 6.98535 9.70903 7.0425 9.56539 7.04259L7.0416 7.04191Z",
    fill: "#DFE0E3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreyCircleDash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grey-circle-dash.3e6ac52f0158d203b42584e7d656d189.svg";